import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { hasCurrentsPermissions } from "@services/useCurrentsPermissions";

const DatasharesIntegrationCreateForNro = lazy(() =>
  import("@scenes/DatasharesIntegration/DatasharesIntegrationCreateForNro").then((module) => ({
    default: module.DatasharesIntegrationCreateForNro,
  }))
);

export const datasharesIntegrationCreateNRO: NavigationRoutingObject = {
  Component: DatasharesIntegrationCreateForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("datashares-create-tab-snowflake-heading", "Create Snowflake Datashare"),
  pageNameForTracking: () => "Create Snowflake Datashare",
  icon: "nav-system-data-sharing",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("datashares_integrations") && hasCurrentsPermissions({ hasPermission }).canEditCurrents;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
